<div class="overview">
  <div class="overview__main">
    <app-overview-header [airport]="airport"></app-overview-header>
    <div class="overview__info">
      <h2 class="overview__info-header">Overview</h2>
      <div class="overview__badges">
        <app-airport-icons [airport]="airport"></app-airport-icons>
      </div>
      <div class="data-block data-block--flush data-block--sm">
        <div class="data-block__item">
          <div class="data-block__label">Attendance:</div>
          <div class="data-block__value">
            <div *ngIf="!isIsland || isSubscribedToIslandGuide; else buyIslandGuide">
              <p *ngIf="airport.attended !== null">{{ airport.attended ? 'Attended' : 'Unattended' }}</p>
              <app-remark-list [remarks]="attendanceRemarks" [compact]="true"></app-remark-list>
            </div>
          </div>
        </div>
        <div class="data-block__item">
          <div class="data-block__label">Runways:</div>
          <div class="data-block__value">
            <div *ngIf="!isIsland || isSubscribedToIslandGuide; else islandGuideOnly">
              <a [routerLink]="['.']" [fragment]="runway.uriFragment" *ngFor="let runway of runways; let last=last">
                {{runway.name}}{{last ? '' : ','}}
              </a>
              <p *ngIf="longestRunwayText">{{longestRunwayText}}</p>
            </div>
          </div>
        </div>
        <div class="data-block__item">
          <div class="data-block__label">Elevation:</div>
          <div class="data-block__value">
            <div *ngIf="!isIsland || isSubscribedToIslandGuide; else islandGuideOnly">
              <ng-container *ngIf="airport.elevation; else na">
                {{airport.elevation | number}} ft
                <ng-container *ngIf="elevationMethod"> ({{ elevationMethod }})</ng-container>
              </ng-container>
            </div>
          </div>
        </div>
        <div class="data-block__item">
          <div class="data-block__label">Tower:</div>
          <div class="data-block__value">
            <div *ngIf="!isIsland || isSubscribedToIslandGuide; else islandGuideOnly">
              <ng-container *ngIf="airport.towered; else notower">
                <!-- <p>{{ towerText }}</p> -->
                <app-remark-list [remarks]="towerRemarks" [compact]="true" [linkify]="false"></app-remark-list>
              </ng-container>
              <ng-template #notower>No</ng-template>
            </div>
          </div>
        </div>
        <div class="data-block__item">
          <div class="data-block__label">Airspace:</div>
          <div class="data-block__value">
            <div *ngIf="!isIsland || isSubscribedToIslandGuide; else islandGuideOnly">
              <app-data-item *ngIf="airport.airspace.twrAirspaceHrs; else noAirspaceTowerHours"
                             [source]="Source.FAA" [compact]="true">
                {{ airport.airspace.twrAirspaceHrs }}
              </app-data-item>
            </div>
          </div>
        </div>
        <div class="data-block__item">
          <div class="data-block__label">Fees:</div>
          <div class="data-block__value">
            <div *ngIf="!isIsland || isSubscribedToIslandGuide; else islandGuideOnly">
                <ng-container *ngIf="fees; else none">{{ fees }}
                  <br><br>
                <i>Click FBO link(s) below for details:</i>
                <div class="airport-overview__extra-space">FBO Fee Details:</div>
                <a [routerLink]="['/business',business.id]" [fragment]="'fees'" *ngFor="let business of fbos" class="airport-overview__fbo-link">{{ business.name }}<br /></a>
                </ng-container>
            </div>
          </div>
        </div>
        <div class="data-block__item">
          <div class="data-block__label">Timezone:</div>
          <div class="data-block__value">
            <div *ngIf="!isIsland || isSubscribedToIslandGuide; else islandGuideOnly">
              <ng-container *ngIf="timeZoneText; else na">
                {{ timeZoneText }}
              </ng-container>
            </div>
          </div>
        </div>
        <div class="data-block__item">
          <div class="data-block__label">Sunrise-Sunset:</div>
          <div class="data-block__value">
            <div>
              <ng-container>
                {{ sunrise }} - {{ sunset }}
              </ng-container>
            </div>
          </div>
        </div>
        <div class="data-block__item">
          <div class="data-block__label">Evening-Morning Civil Twilight:</div>
          <div class="data-block__value">
            <div>
              <ng-container>
                <div class="civil-twilight">{{ pmCivilTwilightEnd }} <br> (Today)</div>
                <div class="civil-twilight">&nbsp;-&nbsp;</div>
                <div class="civil-twilight">{{ amCivilTwilightStart }} <br> (Tomorrow)</div>
              </ng-container>
            </div>
          </div>
        </div>
        <!-- <div class="data-block__item">
          <div class="data-block__label">GA Transient Ramp:</div>
          <div class="data-block__value">
            <mat-icon (click)="openEditGATransientDialog()" *ngIf="editModeSet" class="edit-icon" mat-tooltip="Edit" aria-label="Edit GA Transient Ramp">edit</mat-icon>
            {{ transientRamp }}
            <ng-container *ngIf="airport.afmOther && airport.afmOther.gatParking === true">
              <ng-container *ngIf="airport.afmOther.gatCharted == true; else notChartedPlaceholder">Charted
              </ng-container>
              <p class="airport-overview__extra-space" *ngIf="airport.afmOther.gatDescription">{{airport.afmOther.gatDescription}}
              </p>
            </ng-container>
          </div>
        </div> -->
        <div *ngIf="allFuel.length" class="data-block__item data-block__item--block-label data-block__item--no-border">
          <div class="data-block__label">Minimum Fuel Prices:</div>
          <div class="data-block__value">
            <div class="airport-overview__prices">
              <app-fuel class="airport-overview__price" *ngFor="let fuel of minimumFuelPrices" [fuel]="fuel"></app-fuel>
            </div>
          </div>
        </div>
      </div>
      <div class="overview__actions" >
        <div class="overview__actions-row">
          <a (click)="navigateToTFRs()" mat-button
             class="overview__action aopa-mat-btn aopa-mat-btn--filled"
             *ngIf="!isIsland">
            NOTAMs
          </a>
          <a (click)="navigateToTFRs()" mat-button
             class="overview__action aopa-mat-btn aopa-mat-btn--filled"
             *ngIf="!isIsland">
            TFRs
          </a> <!-- <a mat-button href="https://www.aopa.org/airports/{{airport.identifier}}/kneeboard.pdf" -->
          <a mat-button href="https://www.aopa.org/Kneeboard/Kneeboard/GeneratePdf?airportId={{airport.identifier}}"
             class="overview__action aopa-mat-btn aopa-mat-btn--filled" target="_blank"
             *ngIf="!isIsland"
             [disabled]="isIsland && !isSubscribedToIslandGuide"
             [matTooltip]="notSubscribedTooltip">
            Kneeboard Format
          </a>
          <a (click)="navigateToWx()" mat-button
             class="overview__action aopa-mat-btn aopa-mat-btn--filled"
             [disabled]="isIsland && !isSubscribedToIslandGuide"
             [matTooltip]="notSubscribedTooltip">
            Webcams ({{getWebcamCount()}})
          </a>
        </div>
        <div class="overview__actions-row">
          <a [routerLink]="['/search']" [queryParams]="nearbyParams" mat-button href="#" class="overview__action aopa-mat-btn aopa-mat-btn--filled"
             [disabled]="isIsland && !isSubscribedToIslandGuide"
             [matTooltip]="notSubscribedTooltip">
            Nearby Airports
          </a>
          <a *ngIf="favoriteValid; else disabledFavoriteButton" [routerLink]="['/']" fragment="favorites" mat-button href="#"
            class="overview__action aopa-mat-btn aopa-mat-btn--filled">
           Favorite Airports
          </a>
          <ng-template #disabledFavoriteButton>
            <a mat-button href="#"
               class="overview__action aopa-mat-btn aopa-mat-btn--filled"
               [disabled]="true"
               [matTooltip]="validationReason">
              Favorite Airports
            </a>
          </ng-template>
          <div class="overview__why-here" *ngIf="isIsland">
            <h2>Why Here</h2>
            <p *ngIf="whyHereText && isSubscribedToIslandGuide; else na">
              {{ whyHereText }}
            </p>
            <!--<a mat-button href="#"
               class="aopa-mat-btn aopa-mat-btn&#45;&#45;filled">
              More about {{airport.name}}
            </a>-->
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="overview__chart-container">
    <app-chart-panel [airport]="airport"></app-chart-panel>
    <div class="overview__calculator">
      <app-distance-calculator [airport]="airport"></app-distance-calculator>
    </div>
  </div>
</div>
<ng-template #na>
  <p class="overview__na">N/A</p>
</ng-template>
<ng-template #none>
  <span class="overview__na">None</span>
</ng-template>
<ng-template #noAirspaceTowerHours>
  <ng-container *ngIf="airport.airspace.airspace; else unknown">
    {{ airport.airspace.airspace }}
  </ng-container>
</ng-template>
<ng-template #unknown>
  Unknown
</ng-template>
<ng-template #noPlaceholder>
  No
</ng-template>
<ng-template #notChartedPlaceholder>
  Not Charted
</ng-template>

<ng-template #buyIslandGuide>
  <a mat-button href="https://www.aopa.org/travel/international-travel/bahamas-and-caribbean-pilots-guides"
     class="aopa-mat-btn aopa-mat-btn--filled">
    Buy Island Guide
  </a>
</ng-template>

<ng-template #islandGuideOnly>
  <p>Island Guide subscribers only</p>
</ng-template>
